<template>
	<div>
		<el-dialog
			title="导入结果"
			:visible="show"
			@close="importOpnes"
			center
			width="44%"
		>
			<div style="font-size: 18px" v-if="errorNumber > 0">
				成功<span style="color: #5daf34">{{ succeedNumber }}</span
				>条，失败<span style="color: red;">{{ errorNumber }}</span
				>条。
			</div>
			<div style="font-size: 19px;text-align: center" v-if="errorNumber <= 0">
				<span style="color: #5daf34">导入成功</span>
			</div>
			<el-table
				v-if="errorNumber > 0"
				:data="data.slice((currentPage - 1) * pageSize, currentPage * pageSize)"
			>
				<el-table-column prop="errorRow" label="行数"></el-table-column>
				<el-table-column prop="errorColumn" label="错误列"></el-table-column>
			</el-table>
			<div class="flex flex-end">
				<el-pagination
					class="pagination"
					background
					v-show="data.length > pageSize"
					:current-page.sync="currentPage"
					:page-size.sync="pageSize"
					@size-change="handleSizeChange"
					@current-change="handleCurrentChange"
				>
				</el-pagination>
			</div>
		</el-dialog>
	</div>
</template>

<script>
export default {
	name: "importTips",
	props: {
		show: {
			type: Boolean,
			default: false
		},
		data: {
			type: Array
		},
		succeedNumber: {
			type: Number,
			default: 0
		},
		errorNumber: {
			type: Number,
			default: 0
		}
	},
	data() {
		return {
			currentPage: 1,
			pageSize: 10
		};
	},
	methods: {
		handleSizeChange(val) {
			this.currentPage = 1;
			this.pageSize = val;
		},
		handleCurrentChange(val) {
			this.currentPage = val;
		},
		importOpnes() {
			this.$emit("importOpnes");
		}
	}
};
</script>

<style scoped>
</style>
